import { PurchaseOrder } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 0540. 発注案件編集
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  id: number;
  name: string;
  description: string;
  user_id: number;
  business_partner_id: number;
  person_in_charge?: string;
  payment_context_id: number;
  spot_amount?: number;
  spot_billing_date?: string;
  monthly_amount?: number;
  monthly_billing_start_date?: string;
  monthly_billing_end_date?: string;
  contract_start_date?: string;
  contract_end_date?: string;
  delivery_date?: string;
  payment_method_id: number;
  transfer_information?: string;
  fixed_asset_target: boolean;
  expense_account_item_ids: number[];
};
const updatePurchaseOrder = (props: Props): Promise<PurchaseOrder> => {
  return axios.put(`/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.id}`, props);
};

export const useUpdatePurchaseOrder = () => {
  return useMutation({
    mutationFn: updatePurchaseOrder,
  });
};
